const variaveis = {
    azulEscuro: `#202B40`,
    azul: `#2E3D59`,
    branco: `#F2F2F2`,
    cinza: `#D2D2D4`,
    dourado: `#AE9045FF`,

    atuacoes: ["Direito Civil", "Direito do Trabalho", "Direito Tributário", "Direito do Consumidor"],

    secoes: ["Início", "Áreas de atuação", "Quem somos", "Fale conosco"],

    links: [
        ["Whatsapp", "(71) 9 9244-4691", "https://wa.me/5571992444691", "whatsapp-logo.svg"],
        ["Instagram", "@lucasrvital.adv", "https://www.instagram.com/lucasrvital.adv/", "instagram-logo.svg"],
        ["E-mail", "lucasrvital.adv@gmail.com", "mailto:lucasrvital.adv@gmail.com", "envelope.svg"],
        ["Localização", "Internacional Trade Center, Stiep, Slavador-BA", "https://www.google.com/maps/place/Lucas+R.+Vital+Advogados+Associados/@-12.9871029,-38.4487188,17z/data=!3m1!4b1!4m6!3m5!1s0x4126d34ebd1e6791:0x84d4b1e5af4bab8a!8m2!3d-12.9871029!4d-38.4487188!16s%2Fg%2F11sqkhlqbt?entry=ttu&g_ep=EgoyMDI1MDMxOS4yIKXMDSoASAFQAw%3D%3D", "map-pin.svg"],
    ],

    civil: [
        "Ações de cobrança e execuções",
        "Elaborações e revisões de contratos",
        "Direito de vizinhança e condominial",
        "Ações relacionadas ao direito das famílias",
        "Ações de indenização por dano moral e material",
        "Pareceres verbais e escritos"
    ],

    consumidor: [
        "Revisionais de planos de saúde",
        "Negativação indevida",
        "Problemas com companhias aéreas",
        "Problemas com instituições de ensino",
        "Problemas com instituições financeiras",
        "Vícios com produtos ou serviços",
        "Ações indenizatórias"
    ],

    trabalho: [
        "Reclamações trabalhistas",
        "Defesas trabalhistas",
        "Elaboração de pareceres",
        "Atuação preventiva e consultiva",
        "Acompanhamento, negociação e elaboração de acordos trabalhistas",
        "Assessoria sindical"
    ],

    tributário: [
        "Administração de passivo tributário: acompanhamento e defesa em execuções fiscais e processos administrativos, negociação de débitos junto à administração pública",
        "Recuperação de créditos tributários, administrativo e judicial",
        "Otimização da carga tributária, visando o aumento do lucro e redução dos riscos de atividade empresarial, por meio do planejamento tributário"
    ]
}

export default variaveis